<div class="website-content" style="max-width:72rem;padding:0 var(--wa-spacing-x-large) var(--wa-spacing-x-large) var(--wa-spacing-x-large);">
	<div class="wa-stack wa-gap-xl">
		<wa-button [routerLink]="['/plugins']" appearance="plain" variant="neutral">Back to Plugins</wa-button>
		<wa-card appearance="outlined">
			<div class="wa-stack wa-gap-m">
				<div class="wa-stack wa-gap-s">
					<h1 waHeading="xl" waText>jQuery UI</h1>
					<p waBody="m" waText>jQuery UI 1.14.2 &mdash; curated set of user interface interactions, effects, widgets, and themes built on jQuery. Provides type-safe Java wrappers for 20+ widgets including Accordion, Autocomplete, Datepicker, Dialog, Draggable, Droppable, Slider, Sortable, Tabs, and Tooltips with JSON-serializable options.</p>
					<div class="wa-cluster wa-gap-xs">
						<wa-tag pill variant="neutral">Java 25+</wa-tag>
						<wa-tag pill variant="neutral">jQuery UI 1.14.2</wa-tag>
						<wa-tag pill variant="neutral">jQuery 4.0.0</wa-tag>
						<wa-tag pill variant="neutral">Angular 21</wa-tag>
						<wa-tag pill variant="neutral">TypeScript 5</wa-tag>
						<wa-tag pill variant="neutral">JPMS Modular</wa-tag>
					</div>
				</div>
				<wa-divider></wa-divider>
				<div class="wa-stack wa-gap-xs">
					<div waCaption="s" waFontWeight="semibold" waText>COORDINATES &amp; MODULE</div>
					<p waBody="s" waText>Maven: com.jwebmp.plugins:jquery-ui</p>
					<p waBody="s" waText>JPMS Module: com.jwebmp.plugins.jqueryui</p>
					<p waBody="s" waText>Built on: jQuery UI 1.14.2</p>
				</div>
				<wa-details summary="Installation">
					<div class="wa-stack wa-gap-xs">
						@if (!useGradle) {
							<div class="code-block-wrapper">
								<div class="code-block-label" waCaption="s" waFontWeight="semibold" waText>Maven</div>
								<markdown [data]="mdContent_610" class="aside-snippet-code wa-body-s" clipboard lineNumbers></markdown>
							</div>
						}
						@if (useGradle) {
							<div class="code-block-wrapper">
								<div class="code-block-label" waCaption="s" waFontWeight="semibold" waText>Gradle &#40;Kotlin DSL&#41;</div>
								<markdown [data]="mdContent_611" class="aside-snippet-code wa-body-s" clipboard lineNumbers></markdown>
							</div>
						}
					</div>
				</wa-details>
				<wa-details summary="NPM Dependencies (auto-included)">
					<markdown [data]="mdContent_612" class="aside-snippet-code wa-body-s" clipboard lineNumbers></markdown>
				</wa-details>
				<wa-divider></wa-divider>
				<div class="wa-stack wa-gap-m">
					<h2 waHeading="l" waText>Components &#40;11&#41;</h2>
					<p waBody="m" waText>Click any component to see its full API &mdash; properties, constructors, methods, events, slots, and examples.</p>
					<div class="wa-grid wa-gap-s" style="--min-column-size:18rem;">
						<wa-card appearance="outlined">
							<div class="wa-stack wa-gap-xs">
								<h4 waHeading="s" waText>JQUIAccordion</h4>
								<p waBody="s" waColorText="quiet" waText>Collapsible content panels with animation, easing, and height styles</p>
								<div class="wa-cluster wa-gap-xs">
									<wa-tag pill variant="brand">4 props</wa-tag>
									<wa-tag pill variant="neutral">4 methods</wa-tag>
									<wa-tag pill variant="warning">2 events</wa-tag>
									<wa-tag pill variant="success">1 examples</wa-tag>
								</div>
								<wa-button [routerLink]="['/plugins/jquery-ui/jquiaccordion']" appearance="plain" variant="brand">View Details &rarr;</wa-button>
							</div>
						</wa-card>
						<wa-card appearance="outlined">
							<div class="wa-stack wa-gap-xs">
								<h4 waHeading="s" waText>JQUIAutoComplete</h4>
								<p waBody="s" waColorText="quiet" waText>Autocomplete input with local or AJAX-backed server-side data</p>
								<div class="wa-cluster wa-gap-xs">
									<wa-tag pill variant="brand">4 props</wa-tag>
									<wa-tag pill variant="neutral">4 methods</wa-tag>
									<wa-tag pill variant="warning">3 events</wa-tag>
									<wa-tag pill variant="success">1 examples</wa-tag>
								</div>
								<wa-button [routerLink]="['/plugins/jquery-ui/jquiauto-complete']" appearance="plain" variant="brand">View Details &rarr;</wa-button>
							</div>
						</wa-card>
						<wa-card appearance="outlined">
							<div class="wa-stack wa-gap-xs">
								<h4 waHeading="s" waText>JQUIButton</h4>
								<p waBody="s" waColorText="quiet" waText>Enhanced buttons and button sets with icons and label customization</p>
								<div class="wa-cluster wa-gap-xs">
									<wa-tag pill variant="brand">4 props</wa-tag>
									<wa-tag pill variant="neutral">4 methods</wa-tag>
									<wa-tag pill variant="warning">1 events</wa-tag>
									<wa-tag pill variant="success">1 examples</wa-tag>
								</div>
								<wa-button [routerLink]="['/plugins/jquery-ui/jquibutton']" appearance="plain" variant="brand">View Details &rarr;</wa-button>
							</div>
						</wa-card>
						<wa-card appearance="outlined">
							<div class="wa-stack wa-gap-xs">
								<h4 waHeading="s" waText>JQUIDatePicker</h4>
								<p waBody="s" waColorText="quiet" waText>Full-featured date selection widget with format, range, and locale options</p>
								<div class="wa-cluster wa-gap-xs">
									<wa-tag pill variant="brand">7 props</wa-tag>
									<wa-tag pill variant="neutral">4 methods</wa-tag>
									<wa-tag pill variant="warning">1 events</wa-tag>
									<wa-tag pill variant="success">1 examples</wa-tag>
								</div>
								<wa-button [routerLink]="['/plugins/jquery-ui/jquidate-picker']" appearance="plain" variant="brand">View Details &rarr;</wa-button>
							</div>
						</wa-card>
						<wa-card appearance="outlined">
							<div class="wa-stack wa-gap-xs">
								<h4 waHeading="s" waText>JQUIDialog</h4>
								<p waBody="s" waColorText="quiet" waText>Modal and modeless dialog boxes with configurable buttons and dimensions</p>
								<div class="wa-cluster wa-gap-xs">
									<wa-tag pill variant="brand">8 props</wa-tag>
									<wa-tag pill variant="neutral">5 methods</wa-tag>
									<wa-tag pill variant="warning">3 events</wa-tag>
									<wa-tag pill variant="success">1 examples</wa-tag>
								</div>
								<wa-button [routerLink]="['/plugins/jquery-ui/jquidialog']" appearance="plain" variant="brand">View Details &rarr;</wa-button>
							</div>
						</wa-card>
						<wa-card appearance="outlined">
							<div class="wa-stack wa-gap-xs">
								<h4 waHeading="s" waText>JQUIDraggable</h4>
								<p waBody="s" waColorText="quiet" waText>Make elements draggable with containment, grid, and axis constraints</p>
								<div class="wa-cluster wa-gap-xs">
									<wa-tag pill variant="brand">6 props</wa-tag>
									<wa-tag pill variant="neutral">4 methods</wa-tag>
									<wa-tag pill variant="warning">3 events</wa-tag>
									<wa-tag pill variant="success">1 examples</wa-tag>
								</div>
								<wa-button [routerLink]="['/plugins/jquery-ui/jquidraggable']" appearance="plain" variant="brand">View Details &rarr;</wa-button>
							</div>
						</wa-card>
						<wa-card appearance="outlined">
							<div class="wa-stack wa-gap-xs">
								<h4 waHeading="s" waText>JQUIDroppable</h4>
								<p waBody="s" waColorText="quiet" waText>Define drop targets with accept filtering, tolerance, and visual feedback</p>
								<div class="wa-cluster wa-gap-xs">
									<wa-tag pill variant="brand">4 props</wa-tag>
									<wa-tag pill variant="neutral">3 methods</wa-tag>
									<wa-tag pill variant="warning">3 events</wa-tag>
									<wa-tag pill variant="success">1 examples</wa-tag>
								</div>
								<wa-button [routerLink]="['/plugins/jquery-ui/jquidroppable']" appearance="plain" variant="brand">View Details &rarr;</wa-button>
							</div>
						</wa-card>
						<wa-card appearance="outlined">
							<div class="wa-stack wa-gap-xs">
								<h4 waHeading="s" waText>JQUISlider</h4>
								<p waBody="s" waColorText="quiet" waText>Range and value sliders with step increments and orientation</p>
								<div class="wa-cluster wa-gap-xs">
									<wa-tag pill variant="brand">6 props</wa-tag>
									<wa-tag pill variant="neutral">5 methods</wa-tag>
									<wa-tag pill variant="warning">4 events</wa-tag>
									<wa-tag pill variant="success">1 examples</wa-tag>
								</div>
								<wa-button [routerLink]="['/plugins/jquery-ui/jquislider']" appearance="plain" variant="brand">View Details &rarr;</wa-button>
							</div>
						</wa-card>
						<wa-card appearance="outlined">
							<div class="wa-stack wa-gap-xs">
								<h4 waHeading="s" waText>JQUISortable</h4>
								<p waBody="s" waColorText="quiet" waText>Reorderable lists with drag-and-drop, connected lists, and placeholders</p>
								<div class="wa-cluster wa-gap-xs">
									<wa-tag pill variant="brand">5 props</wa-tag>
									<wa-tag pill variant="neutral">4 methods</wa-tag>
									<wa-tag pill variant="warning">4 events</wa-tag>
									<wa-tag pill variant="success">1 examples</wa-tag>
								</div>
								<wa-button [routerLink]="['/plugins/jquery-ui/jquisortable']" appearance="plain" variant="brand">View Details &rarr;</wa-button>
							</div>
						</wa-card>
						<wa-card appearance="outlined">
							<div class="wa-stack wa-gap-xs">
								<h4 waHeading="s" waText>JQUITabs</h4>
								<p waBody="s" waColorText="quiet" waText>Tabbed content panels with events, animations, and AJAX loading</p>
								<div class="wa-cluster wa-gap-xs">
									<wa-tag pill variant="brand">5 props</wa-tag>
									<wa-tag pill variant="neutral">4 methods</wa-tag>
									<wa-tag pill variant="warning">3 events</wa-tag>
									<wa-tag pill variant="success">1 examples</wa-tag>
								</div>
								<wa-button [routerLink]="['/plugins/jquery-ui/jquitabs']" appearance="plain" variant="brand">View Details &rarr;</wa-button>
							</div>
						</wa-card>
						<wa-card appearance="outlined">
							<div class="wa-stack wa-gap-xs">
								<h4 waHeading="s" waText>JQUIToolTip</h4>
								<p waBody="s" waColorText="quiet" waText>Configurable tooltips with positioning, animation, and custom content</p>
								<div class="wa-cluster wa-gap-xs">
									<wa-tag pill variant="brand">5 props</wa-tag>
									<wa-tag pill variant="neutral">4 methods</wa-tag>
									<wa-tag pill variant="warning">2 events</wa-tag>
									<wa-tag pill variant="success">1 examples</wa-tag>
								</div>
								<wa-button [routerLink]="['/plugins/jquery-ui/jquitool-tip']" appearance="plain" variant="brand">View Details &rarr;</wa-button>
							</div>
						</wa-card>
					</div>
				</div>
				<wa-details summary="Features (21)">
					<div class="wa-stack wa-gap-xs">
						<p waBody="s" waColorText="quiet" waText>Accordion &mdash; collapsible content panels with animation and easing options</p>
						<p waBody="s" waColorText="quiet" waText>Autocomplete &mdash; suggestions with AJAX server-side data support</p>
						<p waBody="s" waColorText="quiet" waText>Button &mdash; enhanced buttons and button sets with icons</p>
						<p waBody="s" waColorText="quiet" waText>Datepicker &mdash; full-featured date selection with localization</p>
						<p waBody="s" waColorText="quiet" waText>Dialog &mdash; modal and modeless dialog boxes with positioning</p>
						<p waBody="s" waColorText="quiet" waText>Draggable &mdash; make elements draggable with containment and grid snapping</p>
						<p waBody="s" waColorText="quiet" waText>Droppable &mdash; define drop targets with accept filtering</p>
						<p waBody="s" waColorText="quiet" waText>Menu &mdash; themeable menu with keyboard navigation</p>
						<p waBody="s" waColorText="quiet" waText>Progress Bar &mdash; determinate and indeterminate progress indicators</p>
						<p waBody="s" waColorText="quiet" waText>Resizable &mdash; make elements resizable with handles and constraints</p>
						<p waBody="s" waColorText="quiet" waText>Selectable &mdash; lasso-selection for element groups</p>
						<p waBody="s" waColorText="quiet" waText>Select Menu &mdash; styled dropdown replacement</p>
						<p waBody="s" waColorText="quiet" waText>Slider &mdash; range and value sliders with steps</p>
						<p waBody="s" waColorText="quiet" waText>Sortable &mdash; reorderable lists with drag-and-drop</p>
						<p waBody="s" waColorText="quiet" waText>Spinner &mdash; numeric input with increment/decrement buttons</p>
						<p waBody="s" waColorText="quiet" waText>Tabs &mdash; tabbed content panels</p>
						<p waBody="s" waColorText="quiet" waText>Tooltips &mdash; configurable tooltips with positioning options</p>
						<p waBody="s" waColorText="quiet" waText>Type-safe options &mdash; all widget options as JSON-serializable Java classes</p>
						<p waBody="s" waColorText="quiet" waText>CRTP fluent API for widget configuration</p>
						<p waBody="s" waColorText="quiet" waText>jQuery UI base theme auto-loaded via CSS</p>
						<p waBody="s" waColorText="quiet" waText>Zero configuration &mdash; auto-registered via ServiceLoader SPI</p>
					</div>
				</wa-details>
				<wa-divider></wa-divider>
				<wa-details open summary="Examples (3)">
					<div class="wa-stack wa-gap-m">
						<div class="wa-stack wa-gap-xs">
							<h4 waHeading="s" waText>Accordion</h4>
							<p waBody="s" waColorText="quiet" waText>Create a collapsible accordion with animated transitions.</p>
							<markdown [data]="mdContent_613" class="aside-snippet-code wa-body-s" clipboard lineNumbers></markdown>
						</div>
						<div class="wa-stack wa-gap-xs">
							<h4 waHeading="s" waText>Dialog</h4>
							<p waBody="s" waColorText="quiet" waText>Create a modal dialog with configurable dimensions.</p>
							<markdown [data]="mdContent_614" class="aside-snippet-code wa-body-s" clipboard lineNumbers></markdown>
						</div>
						<div class="wa-stack wa-gap-xs">
							<h4 waHeading="s" waText>Autocomplete with AJAX</h4>
							<p waBody="s" waColorText="quiet" waText>Server-side autocomplete with AJAX data fetching.</p>
							<markdown [data]="mdContent_615" class="aside-snippet-code wa-body-s" clipboard lineNumbers></markdown>
						</div>
					</div>
				</wa-details>
				<wa-details open summary="Quick Start">
					<markdown [data]="mdContent_616" class="aside-snippet-code wa-body-s" clipboard lineNumbers></markdown>
				</wa-details>
				<wa-divider></wa-divider>
				<wa-details open summary="SPI Extension Point Details (3)">
					<div class="wa-stack wa-gap-s">
						<div class="wa-stack wa-gap-xs">
							<div class="wa-cluster wa-gap-xs">
								<wa-tag pill variant="success">IPageConfigurator</wa-tag>
								<wa-tag pill variant="neutral">provides</wa-tag>
							</div>
							<p waBody="s" waColorText="quiet" waText>JQUIPageConfigurator auto-registers jQuery UI 1.14.2 JS and base theme CSS</p>
						</div>
						<div class="wa-stack wa-gap-xs">
							<div class="wa-cluster wa-gap-xs">
								<wa-tag pill variant="success">IGuiceScanModuleInclusions</wa-tag>
								<wa-tag pill variant="neutral">provides</wa-tag>
							</div>
							<p waBody="s" waColorText="quiet" waText>JQueryUIModuleInclusion includes the jQuery UI module in Guice classpath scanning</p>
						</div>
						<div class="wa-stack wa-gap-xs">
							<div class="wa-cluster wa-gap-xs">
								<wa-tag pill variant="success">IGuiceScanModuleExclusions</wa-tag>
								<wa-tag pill variant="neutral">provides</wa-tag>
							</div>
							<p waBody="s" waColorText="quiet" waText>JQueryUIExclusionsModule excludes unnecessary scan targets for performance</p>
						</div>
					</div>
				</wa-details>
				<wa-details open summary="SPI Extension Points">
					<div class="wa-stack wa-gap-xs">
						<div class="wa-cluster wa-gap-xs">
							<wa-tag pill variant="success">provides IPageConfigurator</wa-tag>
							<wa-tag pill variant="success">provides IGuiceScanModuleInclusions</wa-tag>
							<wa-tag pill variant="success">provides IGuiceScanModuleExclusions</wa-tag>
						</div>
					</div>
				</wa-details>
				<wa-divider></wa-divider>
				<wa-details open summary="Prerequisites">
					<div class="wa-cluster wa-gap-xs">
						<wa-tag pill variant="neutral">Java 25 LTS</wa-tag>
						<wa-tag pill variant="neutral">Maven 3.9+</wa-tag>
						<wa-tag pill variant="neutral">Node.js 18+</wa-tag>
						<wa-tag pill variant="neutral">Angular 21+</wa-tag>
					</div>
				</wa-details>
				<wa-divider></wa-divider>
				<div class="wa-cluster wa-gap-s">
					<wa-tag pill variant="neutral">Upstream: https://jqueryui.com/</wa-tag>
					<wa-tag pill variant="neutral">Docs: https://api.jqueryui.com/</wa-tag>
					<wa-tag pill variant="neutral">Source: https://github.com/JWebMP/JWebMP</wa-tag>
				</div>
			</div>
		</wa-card>
	</div>
</div>